import React from "react";
import icons from "../../../assets/icons/icons";
import "./sms-recipients-setup-banner.scss";
const SMSRecipientsSetUpBanner = () => {
  return (
    <div className="sms-recipients-setup-banner">
      <img src={icons.TermOfServicesInfo} alt="info icon" />
      <p className="sms-recipients-setup-text">
        No Leads or Customers added to the Campaign.
      </p>
    </div>
  );
};

export default SMSRecipientsSetUpBanner;